import { ORDER_STATUS } from "./status"

export const ROUTING_FAILURE_MESSAGE =
  "Order submitted, but approval routing failed. Please contact an admin to fix the routing before it can appear in the approval queue."

export const SUBMIT_SUCCESS_MESSAGE = "Order submitted for approval."

export const SUBMIT_STATE_MISMATCH_MESSAGE =
  "Submit finished, but the order is not in pending status yet. Please refresh and check again."

// Resubmitting after an info_request whose deadline already passed gets
// auto-rejected by the backend instead of going back to pending — still a
// 200 response, so resolveSubmitOutcome needs to name this case specifically
// rather than fall through to the generic state-mismatch message.
export const AUTO_REJECTED_DEADLINE_MESSAGE =
  "The info-request deadline already passed, so this order was automatically rejected instead."

export const buildMissingBudgetMessage = (year) =>
  `No active budget was found for this category in FY ${year}. Please ask Procurement/Admin to create the budget before submitting.`

// BE error envelope is `{ status: false, data: { code, message } }` — the
// axios base query hands that whole envelope back as `error.data`, so the
// real message sits one level deeper at `error.data.data.message`.
export const getApiErrorMessage = (error, fallback) =>
  error?.data?.data?.message || error?.data?.message || error?.message || fallback

export const hasMissingBudgetContext = ({ category, budgetLoading, remaining }) =>
  Boolean(category) && !budgetLoading && remaining == null

export const resolveSubmitOutcome = ({ submitResult, order } = {}) => {
  const status = submitResult?.status || order?.status
  const approvalError = submitResult?.approvalError === true || order?.approvalError === true

  if (approvalError) {
    return {
      kind: "routing-error",
      message: ROUTING_FAILURE_MESSAGE,
    }
  }

  if (status === ORDER_STATUS.PENDING) {
    return {
      kind: "success",
      message: SUBMIT_SUCCESS_MESSAGE,
    }
  }

  if (status === ORDER_STATUS.REJECTED) {
    return {
      kind: "auto-rejected",
      message: AUTO_REJECTED_DEADLINE_MESSAGE,
    }
  }

  return {
    kind: "unexpected-state",
    message: SUBMIT_STATE_MISMATCH_MESSAGE,
  }
}
